import React, { useEffect } from "react";
import PreAuthFilter from "./PreAuthFilter";
import { Button, Grid, Typography } from "@mui/material";
import PreAuthTable from "./PreAuthTable";
import { fetchHealthFacilities, loadingUser } from "../../action";
import PreAuthDetails from "./PreAuthDetails";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Pre_Autharization_Form } from "../../utils/constant";
import { useConvention } from "../../hooks/useConvention";

export default function PreAuthScreen() {
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = useSelector((state) => state.profileReducer);
  const { isConventionnementActive } = useConvention();

  const hanldeClaimScreen = () => {
    navigate(Pre_Autharization_Form);
  };
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  useEffect(() => {
    if (userData?.currentUserResponseData?.i_user?.health_facility_id) {
      dispatch(
        fetchHealthFacilities(
          userData?.currentUserResponseData?.i_user?.health_facility_id
        )
      );
    }
  }, [userData]);
  return (
    <Grid>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          {" "}
          {t("preAuthTitle")}
        </Typography>
        <Grid style={{ marginRight: "20px" }}>
          <Button
            onClick={hanldeClaimScreen}
            variant="outlined"
            component="span"
            color="primary"
            style={{ marginLeft: ".5rem" }}
            disabled={!isConventionnementActive}
          >
            {t("invoice.createRequest")}
          </Button>
        </Grid>
      </Grid>
      <PreAuthFilter></PreAuthFilter>
      <PreAuthTable />
    </Grid>
  );
}
